<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.30176 5.96639H13.3417L15.4926 3.81551H4.30176C1.92596 3.81551 0 5.74147 0 8.11727V23.1734C0 25.5492 1.92596 27.4752 4.30176 27.4752H19.3579C21.7337 27.4752 23.6597 25.5492 23.6597 23.1734V11.9826L21.5092 14.1331V8.11727L21.5088 23.1734C21.5088 24.3613 20.5458 25.3243 19.3579 25.3243H4.30176C3.11386 25.3243 2.15088 24.3613 2.15088 23.1734V8.11727C2.15088 6.92937 3.11386 5.96639 4.30176 5.96639Z"
      fill="#231F20"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.9129 7.67022L19.8076 4.56489L22.0522 2.31914L25.1564 5.42332L22.9129 7.67022ZM14.9174 15.6738L11.4872 15.9861L11.7914 12.58L18.2636 6.10777L21.3701 9.21425L14.9174 15.6738ZM26.8133 3.82054L23.6573 0.664509C22.8035 -0.187009 21.3367 -0.227338 20.5278 0.585003L10.1621 10.9507C9.78643 11.3252 9.55367 11.823 9.50528 12.3495L9.06857 17.1545C9.03862 17.4944 9.1596 17.8308 9.40158 18.0728C9.61935 18.2906 9.91318 18.4104 10.2162 18.4104C10.2519 18.4104 10.2865 18.4093 10.3211 18.4058L15.126 17.9691C15.6537 17.9207 16.1503 17.6891 16.5248 17.3146L26.8917 6.94776C27.7305 6.10662 27.6948 4.70317 26.8133 3.82054Z"
      fill="#231F20"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.9129 7.67022L19.8076 4.56489L22.0522 2.31914L25.1564 5.42332L22.9129 7.67022ZM14.9174 15.6738L11.4872 15.9861L11.7914 12.58L18.2636 6.10777L21.3701 9.21425L14.9174 15.6738ZM26.8133 3.82054L23.6573 0.664509C22.8035 -0.187009 21.3367 -0.227338 20.5278 0.585003L10.1621 10.9507C9.78643 11.3252 9.55367 11.823 9.50528 12.3495L9.06857 17.1545C9.03862 17.4944 9.1596 17.8308 9.40158 18.0728C9.61935 18.2906 9.91318 18.4104 10.2162 18.4104C10.2519 18.4104 10.2865 18.4093 10.3211 18.4058L15.126 17.9691C15.6537 17.9207 16.1503 17.6891 16.5248 17.3146L26.8917 6.94776C27.7305 6.10662 27.6948 4.70317 26.8133 3.82054Z"
      fill="#231F20"
    />
  </svg>
</template>
